<template>
	<div>
		<PageHeader title="Gyöngyöleg napló" />
		<div class="wrapper wrapper-content animated fadeInRight">
			<div class="row">
				<div class="col-lg-12">
					<div class="ibox">
						<div class="ibox-content">
							<div class="row" v-if="wrappings === false">
								<div class="col-12 text-center">
									<h3>Göngyölegek betöltése</h3>
									<i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
								</div>
							</div>
							<div class="widget p-lg text-center" v-if="wrappings.length == 0">
								<div class="m-b-md">
									<i class="fa fa-gift fa-4x"></i>
									<h1 class="m-xs"><i class="fa fa-times"></i></h1>
									<h3 class="font-bold no-margins">
										Nincsenek göngyölegek
									</h3>
									<small>hozzon létre göngyöleget</small>
								</div>
							</div>
							<div class="table-responsive" v-if="wrappings.length != 0 && wrappings !== false">
								<vue-good-table
									styleClass="vgt-table striped" 
									rowStyleClass="fs-12"
									:columns="columns" 
									:rows="wrappings" 
									:search-options="{ enabled: false, placeholder: 'Keresés...' }" 
									:pagination-options="this.$vueGTPaginationOptions"
								>
									<template slot="table-row" slot-scope="props">
										<span v-if="props.column.field == 'quantity'">
											{{props.row.quantity}} db
										</span>
										<span v-else-if="props.column.field == 'actions'">
											<button class="btn btn-success mx-1 d-inline" title="napló" @click="openModal(props.row)"><i class="fa fa-book-open"></i></button>
										</span>
										<span v-else>
											{{props.formattedRow[props.column.field]}}
										</span>
									</template>
								</vue-good-table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div id="modal" >
			<modal-vue modalSize="xl" @on-close="modalClose()" name="wrapping_modal" :headerOptions="{ title: wrapping.name + ' napló', }" :footerOptions="{
			btn1: 'Bezár',
			disableBtn2: true,
			btn1OnClick: () => {
				$vm2.close('wrapping_modal');
			},
		}">
				<div align="center" class="col-12">
					<div class="row" v-if="histories === false">
						<div class="col-12 text-center">
							<h3>Napló betöltése</h3>
							<i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
						</div>
					</div>
					<div class="row" v-if="histories !== false">
						<div class="col-12">
							<h5>Adatok:</h5>
							<table class="table">
								<thead class="thead-light">
									<tr>
										<th>Megnevezés</th>
										<th>Raktárhely</th>
										<th>Típus</th>
										<th>Méret</th>
										<th>Készlet</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{{wrapping.name}}</td>
										<td>{{wrapping.place_name}}</td>
										<td>{{wrapping.type_name}}</td>
										<td>{{wrapping.size}}</td>
										<td>{{wrapping.quantity}} {{wrapping.unit}}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="col-12">
							<button class="btn btn-primary btn-outline" type="button" :class="{'active' : !active}" @click="active = false">Napló</button>
							<button class="btn btn-primary btn-outline" type="button" :class="{'active' : active}" @click="active = true">Műveletek</button>
							<div class="tableFixHead">
								<table class="table table-striped mt-4" v-if="this.active == true">
									<thead class="thead-dark">
										<tr>
											<th>Időpont</th>
											<th>Esemény</th>
											<th>Ár</th>
											<th>Mennyiség</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(history,id) in histories.histories" :key="id">
											<td>{{history.created_date}}</td>
											<td>{{history.event_type}}</td>
											<td>{{history.price ? history.price.toLocaleString('hu-HU')+' Ft' : '-'}}</td>
											<td>{{history.quantity}}</td>
										</tr>
									</tbody>
								</table>
								<table class="table table-striped mt-4" v-if="this.active == false">
									<thead class="thead-dark">
										<tr>
											<th>Időpont</th>
											<th>Esemény</th>
											<th>Megjegyzés</th>
											<th>Felhasználó</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(log,id) in histories.logs" :key="id">
											<td>{{log.created_date}}</td>
											<td>{{log.description}}</td>
											<td>{{log.user_description}}</td>
											<td>{{log.user_name}}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</modal-vue>
		</div>
	</div>
</template>

<script>
import PageHeader from '../../components/PageHeader';
import Log from "../../apis/Log";

export default {
    components: { PageHeader },
    data() {
        return {
					wrappings: false,
					wrapping: {},
					errors: [],
					histories:false,
					active: false,
					columns:[
						{
							label:'Megnevezés',
							field:'name',
							filterOptions : {
								enabled:true,
								placeholder: 'Keresés',
							},
							thClass: 'fs-12'
						},
						{
							label:'Leírás',
							field:'description',
							filterOptions : {
								enabled:true,
								placeholder: 'Keresés',
							},
							thClass: 'fs-12'
						},
						{
							label:'Raktárhely',
							field:'place_name',
							filterOptions : {
								enabled:true,
								placeholder: 'Keresés',
							},
							thClass: 'fs-12'
						},
						{
							label:'Típus',
							field:'type_name',
							filterOptions : {
								enabled:true,
								placeholder: 'Keresés',
							},
							thClass: 'fs-12'
						},
						{
							label:'Aktuális készlet',
							field:'quantity',
							filterOptions : {
								enabled:true,
								placeholder: 'Keresés',
							},
							tdClass: 'text-right',
							thClass: 'fs-12'
						},
						{
							label: 'Műveletek',
							field: 'actions',
							width: '15%',
							sortable: false,
							thClass: 'text-right fs-12',
							tdClass: 'text-right'
						}
					]
        }
    },
	
    created() {
			Log.wrapping()
			.then(response => {
				this.wrappings = response.data;
			});	
    },
    methods: {
			openModal(wrapping) {
				this.wrapping = wrapping
				this.$vm2.open('wrapping_modal')
				Log.log({type:'wrapping',id:wrapping.id})
				.then(response => {
					this.histories = response.data;
					//console.log('histories:',this.histories);
					//console.log('wrapping:',this.wrapping);
				});
			},
			modalClose() {
				this.$vm2.close('wrapping_modal');
				this.histories = false;
			}
    }
};
</script>

<style>
</style>